import script from "./ResourceTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResourceTable.vue?vue&type=script&lang=ts&setup=true"

import "./ResourceTable.vue?vue&type=style&index=0&id=07237166&lang=css"

const __exports__ = script;

export default __exports__